import { Box, Paper, TextField, Typography } from '@mui/material';
import { Field, FieldInputProps, FieldMetaProps, Form } from 'formik';

import { useTranslations } from 'context/TranslationContext';

import {
  ruleFormContentStyle,
  ruleFormHeaderStyle,
  ruleStepIndicatorStyle
} from 'styles/pages/ApprovalRuleFormStyle';

export const RuleBasicInfoSection = () => {
  const { translate } = useTranslations();

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: '1rem',
        border: '1px solid #e5e7eb'
      }}
    >
      <Box sx={ruleFormHeaderStyle}>
        <Box sx={ruleStepIndicatorStyle}>1</Box>
        <Typography
          variant="body1"
          sx={{
            fontSize: '0.75rem',
            fontWeight: 600
          }}
        >
          {translate('labels.ruleName')}
        </Typography>
      </Box>

      <Form>
        <Box sx={ruleFormContentStyle}>
          <Field name="name">
            {({
              field,
              meta
            }: {
              field: FieldInputProps<string>;
              meta: FieldMetaProps<string>;
            }) => (
              <TextField
                {...field}
                fullWidth
                label={translate('labels.ruleName')}
                placeholder={translate('labels.ruleNamePlaceholder')}
                helperText={meta.touched && meta.error ? meta.error : ''}
                error={meta.touched && !!meta.error}
                required
              />
            )}
          </Field>

          <Field
            as={TextField}
            fullWidth
            name="description"
            label={translate('labels.ruleDescription')}
            placeholder={translate('labels.ruleDescriptionPlaceholder')}
            multiline
            rows={3}
          />
        </Box>
      </Form>
    </Paper>
  );
};
